import React from 'react';
import { Button } from '@mui/material';

import { DoctypeDocument } from '@pages/credit/DoctypeDocument';
import { Credit, Doctype, Guarantor } from '@types';
import { useRequest } from '@hooks';
import { creditHttp } from '@network';
import { rbac, ROLES } from '@utils';
import { DownloadIcon, InfoTooltip, LightTooltip } from '@components';
import cls from './credit-documents.module.css';
import CircularProgress from '@mui/material/CircularProgress';

interface CreditDocumentsProps {
  credit: Credit;
  doctypes: Doctype[];
  isSuperadmin: boolean;
  editable: boolean;
  guarantor?: Guarantor;
}

export const CreditDocuments = ({
  credit, doctypes, isSuperadmin, editable, guarantor,
}: CreditDocumentsProps) => {
  const { submit: downloadDocuments, loading: downloadLoading } = useRequest(async () => {
    if (guarantor) {
      await creditHttp.downloadGuarantorDocuments(credit.id, guarantor.id);
    }
  });

  const hasDownloadAccess = rbac.hasDownloadRestrictionRole();

  return (
    <div className={cls._}>
      <div className={cls.actions}>
        {hasDownloadAccess ? (
          <Button
            variant="outlined"
            color="primary"
            onClick={downloadDocuments}
            disabled={downloadLoading}
            className={cls.downloadBtn}>
            <div className={cls.downloadBtnIcon}>
              {downloadLoading
                ? <CircularProgress color="inherit" size={20} />
                : <DownloadIcon />}
            </div>
            Download guarantor documents
          </Button>
        ) : (
          <LightTooltip title={`Requires role: ${ROLES.DOWNLOAD_RESTRICTION}`}>
            <div className={cls.downloadBtn}>
              <InfoTooltip lockIcon title="" />
              Download guarantor documents
            </div>
          </LightTooltip>
        )}
      </div>

      <div className={cls.list}>
        {doctypes.map(doctype => (
          <div className={cls.document} key={doctype.id}>
            <DoctypeDocument
              doctype={doctype}
              credit={credit}
              isSuperadmin={isSuperadmin}
              editable={editable}
              guarantor={guarantor}
              downloadable={rbac.hasDownloadRestrictionRole()}
              uploadable={rbac.hasUploadPermissionRole()}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
